(function () {
    'use strict';

    angular.module("imApp").factory("subOperationService", ['$ihttp', function ($ihttp) {
        let service = {
            getSubOperation: function (parms) {
                return $ihttp.post({
                    method: 2463,
                    parameters: parms || {}
                });
            },
            calculateObj: function (edit) {
                return $ihttp.post({
                    method: 2464,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2465,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2466,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();